

export default function Kosher() {
    return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-6">

          <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 mb-10">
            Kosher Products
          </h2>
        <div className="max-w-3xl text-center p-6 mb-10">
        <p className="text-gray-700 text-lg leading-relaxed ">
          Come see our selection of Kosher products!
        </p>
        </div>  

      {/* Image Section */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8 max-w-5xl">
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQB3h-Q1hCMGXYpGjqD3dvls640h5gjeVWnwA&s"
          className="rounded-2xl shadow-lg w-full h-64 object-cover"
        />
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSVdouQfDyCcIJtRZUoWw9m_sa-9rFuexf9Dg&s"
          alt="Kosher food shelf"
          className="rounded-2xl shadow-lg w-full h-64 object-cover"
        />
        <img
          src="https://static01.nyt.com/images/2010/01/13/dining/13kosherspanSUB-1/articleLarge.jpg?quality=75&auto=webp&disable=upscale"
          alt="woman shopping at grocery store"
          className="rounded-2xl shadow-lg w-full h-64 object-cover"
        />
      </div>

      {/* Description */}
  
    </div>
  );
}